import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../../constants/typography';
import { pickIf } from '../../../../utils/pickIf';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  card: {
    backgroundColor: 'white',
    boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
    borderRadius: '20px',
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginLeft: 0,
    width: '100%',
    '&:first-child': {
      marginTop: theme.spacing(2),
    },
    height: 167,
    [theme.breakpoints.down('md')]: {
      borderRadius: 10,
      height: 147,
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        borderRadius: 10,
        height: 147,
        marginBottom: theme.spacing(2),
      }),
    },
  },
  headerText: {
    color: pickIf(isKiteUser, theme.palette.darkGrey, theme.palette.black),
    fontWeight: pickIf(isKiteUser, FONT_WEIGHT_BOLD, FONT_WEIGHT_SEMIBOLD),
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      paddingRight: theme.spacing(0.5),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: '12px',
        paddingRight: theme.spacing(0.5),
      }),
    },
  },
  text: {
    color: theme.palette.darkGrey,
    fontWeight: pickIf(isKiteUser, FONT_WEIGHT_REGULAR, FONT_WEIGHT_SEMIBOLD),
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: '12px',
      }),
    },
  },
  skipButton: {
    backgroundColor: '#F4F4F4',
    color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.pressed),
    fontWeight: pickIf(isKiteUser, '400', '600'),
    textDecoration: 'none',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  cancel: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('md')]: {
      order: 1,
      width: 100,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        fontSize: 14,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        order: 1,
        width: 100,
      }),
    },
  },
  buttonsContainer: {
    paddingRight: theme.spacing(2.5),
    [theme.breakpoints.down('md')]: {
      order: 4,
      paddingRight: '10px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        order: 4,
        paddingRight: '10px',
      }),
    },
  },
  totalItems: {
    color: theme.palette.red,
  },
}));
